import React from 'react';
import Reset from '../components/Reset';

const ResetPassowrd = () => {
  return (
    <React.Fragment>
      <Reset />
    </React.Fragment>
  );
};

export default ResetPassowrd;